var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageHistoryBlack24Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "manage_history_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#002965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_699"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_464",
    width: 19,
    height: 19,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_700",
    transform: "translate(1.255 1.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_654",
    d: "M18.588,15.168l.9-.792-.792-1.37-1.148.388a2.887,2.887,0,0,0-.855-.5l-.237-1.188H14.875l-.237,1.18a2.887,2.887,0,0,0-.855.5L12.635,13l-.792,1.37.9.792a2.642,2.642,0,0,0,0,1l-.9.792.792,1.37,1.148-.388a2.887,2.887,0,0,0,.855.5l.237,1.2h1.583l.237-1.18a2.887,2.887,0,0,0,.855-.5l1.148.388.792-1.37-.9-.792A2.684,2.684,0,0,0,18.588,15.168ZM15.667,17.25a1.583,1.583,0,1,1,1.583-1.583A1.588,1.588,0,0,1,15.667,17.25ZM9.333,6.167V10.45L11.2,12.318l.823-1.417L10.917,9.8V6.167Zm7.917,3.958A7.118,7.118,0,0,0,4.583,5.66V3.792H3v4.75H7.75V6.958H5.581a5.539,5.539,0,0,1,10.086,3.167ZM9.222,15.6a5.553,5.553,0,0,1-4.576-4.679h-1.6a7.125,7.125,0,0,0,7.077,6.333h.055Z",
    transform: "translate(-3 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageHistoryBlack24Dp);
export default __webpack_public_path__ + "static/media/manage_history_black_24dp.d5661e027bdc3432072d5525c0739b9f.svg";
export { ForwardRef as ReactComponent };